<script>
import baseMixin from '@/mixins/baseMixin'
import { TimesheetOperationTypeInts } from '@/constants/disputes/TimesheetOperationType'
import timesheetMixin from '@/mixins/timesheetMixin'

/**
 * Returns this value if client or candidate stated did not happen
 */
const DID_NOT_SUBMIT_DELTA_CODE = 9999

export default {
  name: 'DisputesTableSimpleDeltaV2',
  mixins: [baseMixin, timesheetMixin],
  props: {
    dispute: {
      type: Object,
      required: true,
    },
  },
  computed: {
    candidateHasSubmitted() {
      return this.candidateHasSubmittedTimesheet(this.dispute.bookingStatus)
    },
    clientHasSubmitted() {
      return this.clientHasSubmittedTimesheet(this.dispute.bookingStatus)
    },
    hasCandidateModifiedTimesheet() {
      if (!this.candidateHasSubmitted) return false
      return (
        this.dispute.candidateTimesheet.operationType ===
        TimesheetOperationTypeInts.MODIFY
      )
    },
    hasClientModifiedTimesheet() {
      if (!this.clientHasSubmitted) return false
      return (
        this.dispute.clientTimesheet.operationType ===
        TimesheetOperationTypeInts.MODIFY
      )
    },
    candidateSubmittedDidNotHappen() {
      if (!this.candidateHasSubmitted) return false
      return (
        this.dispute.candidateTimesheet.operationType ===
        TimesheetOperationTypeInts.CANCEL
      )
    },
    clientSubmittedDidNotHappen() {
      if (!this.clientHasSubmitted) return false
      return (
        this.dispute.clientTimesheet.operationType ===
        TimesheetOperationTypeInts.CANCEL
      )
    },
    showDelta() {
      return (
        (this.hasCandidateModifiedTimesheet ||
          this.hasClientModifiedTimesheet ||
          this.candidateSubmittedDidNotHappen ||
          this.clientSubmittedDidNotHappen) &&
        this.dispute.deltaMinutes !== 0
      )
    },
    isDidNotHappen() {
      return this.dispute.deltaMinutes === DID_NOT_SUBMIT_DELTA_CODE
    },
    compDidNotHappenTooltipText() {
      return `${
        this.candidateSubmittedDidNotHappen
          ? this.dispute.candidateName
          : this.dispute.clientName
      } stated this booking did not happen`
    },
    isPositiveDelta() {
      return this.dispute.deltaMinutes >= 0
    },
    compDeltaMins() {
      const deltaMins = Math.abs(this.dispute.deltaMinutes)

      if (deltaMins === 0) return ''

      return `${deltaMins} mins`
    },
  },
}
</script>

<template>
  <div v-if="showDelta">
    <div v-if="isDidNotHappen">
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <div v-bind="attrs" class="cursor-help" v-on="on">
            <v-icon size="14">mdi-alert-circle-outline</v-icon>
            <span class="text-caption ml-1">Didn't happen</span>
          </div>
        </template>
        <span class="ws-pre-wrap">{{ compDidNotHappenTooltipText }}</span>
      </v-tooltip>
    </div>
    <div v-else class="text-caption">
      <v-icon size="14">{{
        isPositiveDelta ? 'mdi-plus' : 'mdi-minus'
      }}</v-icon>
      <span class="text-caption ml-1">{{ compDeltaMins }}</span>
    </div>
  </div>
</template>
